<template>
  <div>

    <lightbox activateCommand="open_userSettings" deactivateCommand="close_userSettings" customClass="bg-color-darkgray rounded-border" special_lightbox="user_settings_lightbox">
      <user-settings/>
    </lightbox>

    <lightbox activateCommand="open_creatorProfiles" deactivateCommand="close_creatorProfiles" customClass="bg-color-darkgray rounded-border">
      <creator-profiles/>
    </lightbox>

    <lightbox activateCommand="open_contract" deactivateCommand="close_contract" customClass="bg-white rounded-border">
      <contract/>
    </lightbox>

 
    <lightbox activateCommand="open_programm" deactivateCommand="close_programm" customClass="bg-white max-width-3 rounded-border">
      <programm/>
    </lightbox>
    <div class="ui-topbar  flex justify-between col-12">
      <div class="flex justify-between">
        <img class="cbx-logo" src="../assets/CQL_logo_kombi.svg">
      </div>
      <div class="flex align-middle pr4 white mt2">
        <!-- <div class="relative mr2">
          <img class="dropdown-arrow " style="width: 10px; height: 54px; " src="../assets/dropdown-arrow-white.svg">
          <select class="user-input dimmed px1 rounded small" style="color:var(--medium-gray);border: 2px solid var(--color-darkgray);background:transparent;width: 124px; height: 54px;" v-model="$i18n.locale" @change="callRecalculateStiffness()">
            <option class="white"
              v-for="(lang, i) in langs"
              :key="`Lang${i}`"
              :value="lang.value"
              >{{ lang.label }}</option
            >
          </select>
        </div> -->


        <!-- TEMPORARY WARNING 24.02.2023 FH -->
        <div 
          @click="showDownloadPopup = true" 
          class="mr2 px2 border-box flex flex-column justify-center pointer" 
          style="outline: 2px solid #0056FF; outline-offset: -2px; height: 54px; border-radius: 4px;">
          <h3 class="h2 regular white">{{$t('cql-headerbar-download-area-heading')}}</h3>
        </div>

        <div class="flex bg-color-gray p1 justify-between border-box mr2 user-settings-profile" style="border-radius: 5px; height: 54px;">
          <div class="flex align-middle">
            <svg class="user-icon mr1 p1" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.25 18.75V21.75C23.25 22.5784 22.5784 23.25 21.75 23.25H18.75" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18.75 0.75H21.75C22.5784 0.75 23.25 1.42157 23.25 2.25V5.25" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M0.75 5.25V2.25C0.75 1.42157 1.42157 0.75 2.25 0.75H5.25" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.25 23.25H2.25C1.42157 23.25 0.75 22.5784 0.75 21.75V18.75" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="12" cy="9" r="4.125" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18.365 19.125C17.4114 16.4275 14.8611 14.624 12 14.624C9.13894 14.624 6.58858 16.4275 5.63501 19.125" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <div>
            <p class="mr2 h4 color-lightgray mb0">{{userdata.firstname}} {{userdata.name}}</p>
            <p class="mr2 p-small color-lightgray" style="margin-top: -5px;">{{userdata.email}}</p>
            </div>

            <div class="relative ">
              <!-- <svg @click="openUserSettings()" class="px2 py1 pointer" width="30" height="30" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.387 6.25333C11.6025 6.49149 11.9088 6.62736 12.23 6.62736C12.5512 6.62736 12.8574 6.49149 13.073 6.25333L13.618 5.65333C13.9399 5.29676 14.4513 5.18143 14.8951 5.36535C15.3388 5.54927 15.6187 5.99261 15.594 6.47233L15.553 7.28433C15.5364 7.60526 15.6567 7.91817 15.8839 8.1454C16.1112 8.37264 16.4241 8.49289 16.745 8.47633L17.557 8.43433C18.037 8.40952 18.4806 8.68974 18.6644 9.13387C18.8481 9.57801 18.7322 10.0897 18.375 10.4113L17.775 10.9563C17.5363 11.1714 17.4 11.4776 17.4 11.7988C17.4 12.1201 17.5363 12.4263 17.775 12.6413L18.375 13.1863C18.7322 13.5079 18.8481 14.0196 18.6644 14.4638C18.4806 14.9079 18.037 15.1881 17.557 15.1633L16.745 15.1213C16.4239 15.1047 16.1108 15.2251 15.8835 15.4526C15.6563 15.68 15.5361 15.9932 15.553 16.3143L15.594 17.1263C15.6187 17.606 15.3388 18.0494 14.8951 18.2333C14.4513 18.4172 13.9399 18.3019 13.618 17.9453L13.073 17.3453C12.8574 17.1072 12.5512 16.9713 12.23 16.9713C11.9088 16.9713 11.6025 17.1072 11.387 17.3453L10.843 17.9453C10.5208 18.3015 10.0095 18.4165 9.5658 18.2327C9.12211 18.0489 8.84195 17.606 8.86599 17.1263L8.90699 16.3143C8.92589 15.9922 8.80681 15.6773 8.57952 15.4483C8.35224 15.2193 8.03822 15.0979 7.71599 15.1143L6.90399 15.1563C6.42435 15.1804 5.9814 14.9002 5.7976 14.4565C5.6138 14.0128 5.72886 13.5015 6.08499 13.1793L6.68499 12.6343C6.92311 12.419 7.05896 12.1129 7.05896 11.7918C7.05896 11.4708 6.92311 11.1647 6.68499 10.9493L6.08499 10.4043C5.732 10.0821 5.61839 9.57349 5.80078 9.13174C5.98316 8.68999 6.42252 8.40963 6.89999 8.43033L7.71199 8.47233C8.03343 8.48977 8.34716 8.36991 8.57507 8.14257C8.80298 7.91523 8.92363 7.60181 8.90699 7.28033L8.86599 6.46833C8.84195 5.98868 9.12211 5.54573 9.5658 5.36193C10.0095 5.17813 10.5208 5.29319 10.843 5.64933L11.387 6.25333Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12.23" cy="11.7953" r="2.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="0.75" y="1.06531" width="22.5" height="22.5" rx="1.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>  -->
            </div>

            <dropdown 
              :menuItems="{
                'item1':{
                  id: 1,
                  name: this.$t('cql-headerbar_your_data'),
                  modal: 'userSettings'
                },
                'item2':{
                  id: 2,
                  name: this.$t('cql-headerbar_creator_profiles'),
                  modal: 'creatorProfiles'
                },
                'item3':{
                  id: 3,
                  name: this.$t('cql-headerbar_program'),
                  modal: 'programm'
                },
                'item4':{
                  id: 4,
                  name: this.$t('cql-headerbar_contract'),
                  modal: 'contract'
                }
              }"
            />


          </div>
        </div>
        <a class="pointer bg-color-red logout" style="height: 54px; border-radius: 5px; margin-right: 94px" @click="showAskLogout = true">
          <svg height="100%" viewBox="0 0 63 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.9575 28.0925C27.8331 28.2597 27.8478 28.4924 27.9923 28.6425C28.1675 28.8209 28.4097 28.9174 28.6597 28.9084H33.9653C34.2152 28.9174 34.4574 28.8209 34.6327 28.6425C34.7772 28.4924 34.7919 28.2597 34.6675 28.0925L32.0137 24.4002C31.8337 24.2034 31.5792 24.0914 31.3125 24.0914C31.0458 24.0914 30.7913 24.2034 30.6112 24.4002L27.9575 28.0925Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="31.3125" cy="28.3125" r="10.3125" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M34.8078 31.6537H27.9328" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
    </div>
    <div class="lightbox" v-show="showAskLogout">
      <div class="lightbox-box p4 bg-color-darkgray rounded-border flex-column">
        <button class="lightbox-close-btn" @click="showAskLogout = false">
            <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
        <h3 class="white h2 center mb4">{{ $t('logout_modal_reallylogout_question') }}</h3>
        <div class="flex mx-auto">
          <button class="btn btn-bg-red btn-small mr3"  @click="showAskLogout = false">{{ $t('logout_modal_reallylogout_no') }}</button>
          <button class="btn btn-small btn-no-arrow ml3 pl4" @click="logOut()">{{ $t('logout_modal_reallylogout_yes') }}</button>
        </div>
      </div>
    </div>

    <!-- Download Popup -->
    <div class="lightbox" v-show="showDownloadPopup">
      <div class="lightbox-box p4 bg-white max-width-2 rounded-border flex-column border-box col-12">
        <button class="lightbox-close-btn" @click="showDownloadPopup = false">
            <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
        <h3 class="black h0 bold mb3">{{$t('cql-headerbar-download-area-popup-heading')}}</h3>
        <div v-show="$i18n.locale == 'de'" class="flex flex-column" style="gap: 1rem;">
          <a 
            v-for="item in downloadItemsDE" 
            :key="item.id" 
            :href="`https://media.cobiax.com/public-downloads-cql/cql-intl-download-de/download/${item.id}/${item.crypt}/${session.user_id}/${session.token}`" 
            class="btn btn-small col-12 border-box gray flex" 
            style="justify-content: space-between; align-items:center;"
            target="_blank"
          >
            <span>{{item.name}}</span>
            <svg style="width: 1.5rem; height: 1.5rem; transform: rotate(180deg)" width="170" height="201" viewBox="0 0 170 201" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M165.49 93.4899C164.375 94.6086 163.051 95.4963 161.592 96.1019C160.133 96.7076 158.569 97.0194 156.99 97.0194C155.411 97.0194 153.847 96.7076 152.388 96.1019C150.93 95.4963 149.605 94.6086 148.49 93.4899L97.0001 41.9999V189C97.0001 192.183 95.7358 195.235 93.4853 197.485C91.2349 199.736 88.1827 201 85.0001 201C81.8175 201 78.7652 199.736 76.5148 197.485C74.2643 195.235 73.0001 192.183 73.0001 189V41.9999L21.4901 93.4899C19.2357 95.7443 16.1782 97.0107 12.9901 97.0107C9.80194 97.0107 6.7444 95.7443 4.49006 93.4899C2.23571 91.2356 0.969238 88.178 0.969238 84.9899C0.969238 81.8018 2.23571 78.7443 4.49006 76.4899L76.4901 4.48991C77.6049 3.37119 78.9296 2.48355 80.3882 1.87789C81.8469 1.27222 83.4107 0.960449 84.9901 0.960449C86.5694 0.960449 88.1333 1.27222 89.5919 1.87789C91.0505 2.48355 92.3752 3.37119 93.4901 4.48991L165.49 76.4899C166.609 77.6048 167.496 78.9295 168.102 80.3881C168.708 81.8467 169.02 83.4105 169.02 84.9899C169.02 86.5693 168.708 88.1331 168.102 89.5917C167.496 91.0504 166.609 92.3751 165.49 93.4899Z" fill="white"/>
            </svg>
          </a>
        </div>
        <div v-show="$i18n.locale == 'en'" class="flex flex-column" style="gap: 1rem;">
          <a 
            v-for="item in downloadItemsEN" 
            :key="item.id" 
            :href="`https://media.cobiax.com/public-downloads-cql/cql-intl-download-en/download/${item.id}/${item.crypt}/${session.user_id}/${session.token}`" 
            class="btn btn-small col-12 border-box gray flex" 
            style="justify-content: space-between; align-items:center;"
            target="_blank"
          >
            <span>{{item.name}}</span>
            <svg style="width: 1.5rem; height: 1.5rem; transform: rotate(180deg)" width="170" height="201" viewBox="0 0 170 201" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M165.49 93.4899C164.375 94.6086 163.051 95.4963 161.592 96.1019C160.133 96.7076 158.569 97.0194 156.99 97.0194C155.411 97.0194 153.847 96.7076 152.388 96.1019C150.93 95.4963 149.605 94.6086 148.49 93.4899L97.0001 41.9999V189C97.0001 192.183 95.7358 195.235 93.4853 197.485C91.2349 199.736 88.1827 201 85.0001 201C81.8175 201 78.7652 199.736 76.5148 197.485C74.2643 195.235 73.0001 192.183 73.0001 189V41.9999L21.4901 93.4899C19.2357 95.7443 16.1782 97.0107 12.9901 97.0107C9.80194 97.0107 6.7444 95.7443 4.49006 93.4899C2.23571 91.2356 0.969238 88.178 0.969238 84.9899C0.969238 81.8018 2.23571 78.7443 4.49006 76.4899L76.4901 4.48991C77.6049 3.37119 78.9296 2.48355 80.3882 1.87789C81.8469 1.27222 83.4107 0.960449 84.9901 0.960449C86.5694 0.960449 88.1333 1.27222 89.5919 1.87789C91.0505 2.48355 92.3752 3.37119 93.4901 4.48991L165.49 76.4899C166.609 77.6048 167.496 78.9295 168.102 80.3881C168.708 81.8467 169.02 83.4105 169.02 84.9899C169.02 86.5693 168.708 88.1331 168.102 89.5917C167.496 91.0504 166.609 92.3751 165.49 93.4899Z" fill="white"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import dropdown from './dropdown.vue';
import lightbox from './lightbox.vue';
import userSettings from './userSettings.vue';
import contract from './contract.vue';
import programm from './programm.vue';
import creatorProfiles from './creatorProfiles.vue';

import { EventBus } from "../event-bus";
import Axios from 'axios';

export default {
  name: "CQLHeaderbar",
  data() {
    return {
      showDownloadPopup: false, 
      showAskLogout: false,
      langs: [
        {value: 'de', label: 'Deutsch'}, 
        {value: 'en', label: 'English (metric)'}, 
      ],
      userdata: {},
      session: {},
      loginStatus: false,
      downloadItemsDE: [],
      downloadItemsEN: []

    };
  },
  created: function () {

    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      this.userdata = payload.userdata;
      this.session = payload.session;
      this.loginStatus = true;
      this.fetchDownloadFiles();
    });

    EventBus.$on('closeSettingsModal', () => {
      this.showUserSettings = false;
    });
    
  },
  components: {
    'dropdown': dropdown,
    'lightbox': lightbox,
    'user-settings': userSettings,
    'contract': contract,
    'programm': programm,
    'creator-profiles': creatorProfiles,
  },
  methods: {
    logOut(){
      this.$router.push({ path: '/' + this.$i18n.locale + "/logout" })
    },
    openUserSettings(){
      this.showUserSettings = !this.showUserSettings;
      EventBus.$emit('loadUserProfileData');
    },
    fetchDownloadFiles(){
      console.log('fetching download files!');
      console.log(this.session);
      Axios.post('https://media.cobiax.com/quickandlightapp/get-cql-internal-downloads/cql-intl-download-de/json', this.session)
        .then(response => {
          console.log(response)
          for(let i = 0; i < response.data.data[0].files.length; i++){
            response.data.data[0].files[i].channel = response.data.data[0].channel_id
            this.downloadItemsDE.push(response.data.data[0].files[i])

          }
        })
        .catch(err => console.log(err))

      Axios.post('https://media.cobiax.com/quickandlightapp/get-cql-internal-downloads/cql-intl-download-en/json', this.session)
        .then(response => {
          console.log(response)
          for(let i = 0; i < response.data.data[0].files.length; i++){
            response.data.data[0].files[i].channel = response.data.data[0].channel_id
            this.downloadItemsEN.push(response.data.data[0].files[i])

          }
        })
        .catch(err => console.log(err))
    }
  }

};
</script>
<style scoped>

</style>